<template>
    <SidebarItem icon="users" link="/admin/users" :label="$t('admin.sidebar.users')" />
    <SidebarItem icon="feedbacks" link="/call-center-boss/feedbacks" :label="$t('admin.sidebar.feedbacks')" :badgeCount="$store.state.feedback.count" />
    <SidebarItem icon="chat" link="/admin/chat" :label="$t('admin.sidebar.chat')" :badgeCount="$store.state.chat.newChatCount" />
    <SidebarItem icon="questionaree" link="/admin/questionnaire" :label="$t('admin.sidebar.questionnaire')" />
    <SidebarItem icon="category" link="/admin/treatment-category" :label="$t('table.treatment_category')" />
    <SidebarItem icon="orders" link="/admin/orders" :label="$t('admin.sidebar.orders')" />
    <SidebarItem icon="promo_codes" link="/admin/promo-codes" :label="$t('admin.sidebar.promo_codes')" />
    <SidebarItem icon="map" link="/admin/map" :label="$t('admin.sidebar.map')" />
    <SidebarItem
        :badgeCount="$store.state.feedback.countSupport"
        icon="technical_support"
        link="/admin/technical_support"
        :label="$t('admin.sidebar.technical_support')"
    />
</template>

<script setup>
    import SidebarItem from '@/components/sidebar/SidebarItem.vue';
    import { onMounted } from 'vue';
    import { useChatSocket, useFeedbackSocket } from '@/services/socket';
    import { useStore } from 'vuex';

    const store = useStore();

    onMounted(() => {
        //listen call center boss role socket
        store.dispatch('chat/getChatCountsForCallCenterBoss');
        store.dispatch('feedback/getCountsForCallCenterBoss');
        store.dispatch('feedback/getTechnicalSupportCounts');

        useChatSocket(() => {
            store.dispatch('chat/getChatCountsForCallCenterBoss');
        });

        useFeedbackSocket(() => {
            store.dispatch('feedback/getCountsForCallCenterBoss');
        });
    });
</script>
